
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Forceurbaniarentalinaundhpune() {



    const cardData =
    {
        keyword: 'Force Urbania rental in Aundh Pune  ',
        heading: 'Amruta Travels: Force Urbania rental in Aundh Pune',
        headingDescription: 'Amruta Travels offers Force Urbania Rental in Aundh Pune, providing a comfortable and reliable solution for corporate trips, family outings, airport transfers, school excursions, and weekend getaways. Our 13-seater and 17-seater Force Urbania vans come with spacious interiors, air-conditioning, and modern amenities for a smooth and enjoyable journey. With professional drivers, punctual service, competitive pricing, and 24/7 support, Amruta Travels ensures safe, convenient, and hassle-free Force Urbania rentals in Aundh Pune.',


        top: 'Top Places to Visit in Pune with Amruta Travels',

    "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas of the Maratha Empire, Shaniwar Wada is a historic fort in central Pune. Known for its massive Delhi Gate, beautiful gardens, and tales of royal intrigue, it's a major attraction. Don't miss the evening light and sound show that narrates its rich past."
  },
  {
    "title": "Aga Khan Palace",
    "description": "An architectural gem and a symbol of India’s freedom struggle, the Aga Khan Palace was built in 1892. It once housed Mahatma Gandhi and his wife Kasturba. Today, it features a museum with personal artifacts, peaceful gardens, and memorials."
  },
  {
    "title": "Sinhagad Fort",
    "description": "This hilltop fort, located 35 km from Pune, is famous for its historic Battle of Sinhagad and stunning views. A popular trekking destination, it offers visitors a mix of adventure, history, and local Maharashtrian snacks like pithla-bhakri."
  },
  {
    "title": "Osho Ashram",
    "description": "Nestled in the lush greenery of Koregaon Park, Osho International Meditation Resort is a spiritual retreat offering meditation, wellness workshops, and mindfulness programs. It attracts global visitors looking for peace and transformation."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Dating back to the 8th century, this rock-cut temple dedicated to Lord Shiva is carved from a single basalt rock. Located in the heart of Pune, it’s a peaceful oasis amidst the city bustle with detailed stone carvings and spiritual ambiance."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This one-of-a-kind museum showcases over 20,000 artifacts including musical instruments, weapons, sculptures, and art pieces. It’s a window into India’s rich cultural history, curated lovingly by Dr. Dinkar Kelkar in memory of his son."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "A popular weekend spot just outside Pune, Khadakwasla Dam is perfect for a scenic drive, evening stroll, or picnic. The serene waters, cool breeze, and roadside food vendors make it a relaxing escape from the city."
  },
  {
    "title": "Fergusson College Road",
    "description": "A youthful and energetic area filled with cafes, eateries, and shopping outlets, Fergusson College Road is a go-to spot for college students and tourists alike. From fashion finds to tasty street food, it offers a lively Pune experience."
  },
  {
    "title": "Lal Mahal",
    "description": "Originally built in the 1630s by Shahaji Bhosale, Lal Mahal is linked to the childhood of Chhatrapati Shivaji Maharaj. The reconstructed palace features exhibits and murals depicting the Maratha warrior’s early life and battles."
  },
  {
    "title": "Pune-Okayama Friendship Garden",
    "description": "Inspired by Japan’s Korakuen Garden, this beautifully landscaped park features flowing streams, stone bridges, koi ponds, and walking paths. It's a serene and photogenic spot ideal for families and couples."
  }
],



"services": [
  {
    "name": "Urbania on rent in Kothrud Pune",
    "description": "Urbania on rent in Kothrud Pune providing premium and comfortable group travel solutions for families, corporates, and tourists. Ideal for city travel, airport transfers, weddings, picnics, and outstation trips with fully air-conditioned interiors, plush pushback seating, ample legroom, spacious luggage area, clean cabins, and professional drivers ensuring safe, smooth, and punctual journeys."
  },
  {
    "name": "Force Urbania on rent Kothrud",
    "description": "Force Urbania on rent in Kothrud offering luxury mini bus services for small and medium-sized groups. Well-maintained AC vehicles with modern interiors, comfortable seating, strong suspension, and experienced drivers familiar with Kothrud and Pune routes."
  },
  {
    "name": "Urbania rental service Kothrud",
    "description": "Urbania rental service in Kothrud delivering reliable and flexible transportation for corporate offices, families, and event travel. Enjoy AC comfort, clean interiors, sufficient luggage space, and punctual service every time."
  },
  {
    "name": "Urbania Bus hire in Kothrud",
    "description": "Urbania bus hire in Kothrud for group travel including family outings, weddings, corporate events, and tours. Spacious AC interiors, comfortable seating, safety features, and trained drivers ensure a relaxed travel experience."
  },
  {
    "name": "Urbania on rent near Kothrud Pune",
    "description": "Urbania on rent near Kothrud Pune with quick availability and doorstep pickup. Suitable for residential societies, corporate guests, and tourists seeking luxury and dependable travel."
  },
  {
    "name": "13 seater Urbania on rent Kothrud",
    "description": "13 seater Urbania on rent in Kothrud ideal for family trips, airport transfers, and small corporate groups. Features AC interiors, pushback seats, ample luggage space, and experienced chauffeurs."
  },
  {
    "name": "17 seater Urbania on rent Kothrud",
    "description": "17 seater Urbania on rent in Kothrud for larger groups and corporate teams. Luxury AC interiors, spacious seating layout, excellent legroom, and smooth ride quality ensure premium group travel."
  },
  {
    "name": "Luxury Urbania hire Kothrud",
    "description": "Luxury Urbania hire in Kothrud for premium travel needs such as weddings, VIP guests, and executive movement. Elegant AC interiors, plush seating, and professional drivers deliver a high-end experience."
  },
  {
    "name": "AC Urbania Bus hire Kothrud",
    "description": "AC Urbania bus hire in Kothrud offering cool, comfortable, and relaxed journeys. Ideal for all seasons with powerful air-conditioning, clean interiors, and comfortable seating."
  },
  {
    "name": "Force Urbania 17 seater Kothrud",
    "description": "Force Urbania 17 seater in Kothrud suitable for corporate travel, family outings, and outstation tours. Provides AC comfort, spacious interiors, luggage capacity, and skilled drivers for long journeys."
  },
  {
    "name": "Urbania on rent near Karve Nagar",
    "description": "Urbania on rent near Karve Nagar for family, corporate, and airport travel. Luxury AC vehicles with punctual service and professional chauffeurs."
  },
  {
    "name": "Urbania hire near Paud Road Kothrud",
    "description": "Urbania hire near Paud Road Kothrud for easy access to city travel, airport transfers, and group tours with AC comfort and reliable service."
  },
  {
    "name": "Urbania rental near Ideal Colony",
    "description": "Urbania rental near Ideal Colony Kothrud for residential and corporate travel needs. Clean AC interiors, spacious seating, and courteous drivers ensure smooth journeys."
  },
  {
    "name": "Urbania Bus hire near Bavdhan",
    "description": "Urbania bus hire near Bavdhan for family trips, picnics, weddings, and corporate outings. Offers spacious AC interiors and dependable service."
  },
  {
    "name": "Urbania on rent near Warje Malwadi",
    "description": "Urbania on rent near Warje Malwadi providing luxury group travel with AC comfort, ample seating, and experienced drivers."
  },
  {
    "name": "Urbania on rent Kothrud for family trip",
    "description": "Urbania on rent in Kothrud for family trips offering safety, comfort, and space. Ideal for vacations, temple visits, and leisure outings."
  },
  {
    "name": "Urbania hire Kothrud for outstation",
    "description": "Urbania hire in Kothrud for outstation travel to Lonavala, Mahabaleshwar, Shirdi, Mumbai, and more with AC comfort and reliable vehicles."
  },
  {
    "name": "Urbania rental Kothrud for wedding",
    "description": "Urbania rental in Kothrud for wedding transportation. Perfect for guest and family movement with luxury AC interiors and professional chauffeurs."
  },
  {
    "name": "Urbania hire Kothrud for corporate travel",
    "description": "Urbania hire in Kothrud for corporate meetings, conferences, seminars, and employee transport. Premium AC interiors and disciplined drivers meet corporate standards."
  },
  {
    "name": "Urbania van hire Kothrud for picnic",
    "description": "Urbania van hire in Kothrud for picnics and group outings. Comfortable AC seating, spacious interiors, and smooth rides for enjoyable trips."
  },
  {
    "name": "Urbania airport pickup from Kothrud",
    "description": "Urbania airport pickup from Kothrud ensuring punctual arrivals, AC comfort, and sufficient luggage space for families and corporate guests."
  },
  {
    "name": "Urbania Pune Airport drop from Kothrud",
    "description": "Urbania Pune Airport drop service from Kothrud with timely departures, luxury AC interiors, and stress-free travel."
  },
  {
    "name": "Urbania hire Kothrud for airport transfer",
    "description": "Urbania hire in Kothrud for airport transfers with reliable pickup and drop, AC comfort, and experienced airport-route drivers."
  },
  {
    "name": "Urbania Bus hire Kothrud to airport",
    "description": "Urbania bus hire from Kothrud to airport for group transfers with spacious AC interiors and ample luggage space."
  },
  {
    "name": "Urbania on rent Kothrud price",
    "description": "Urbania on rent price in Kothrud offering transparent and competitive rates with premium AC vehicles and professional service."
  },
  {
    "name": "Urbania hire Kothrud per km rate",
    "description": "Urbania hire in Kothrud available on per km basis for local and outstation travel with flexible and affordable pricing."
  },
  {
    "name": "Affordable Urbania Rental Kothrud",
    "description": "Affordable Urbania rental in Kothrud providing luxury travel at budget-friendly prices without compromising comfort or safety."
  },
  {
    "name": "Cheap Urbania on rent Kothrud",
    "description": "Cheap Urbania on rent in Kothrud for economical group travel with AC comfort, clean vehicles, and reliable drivers."
  },
  {
    "name": "Best Urbania Rental service Kothrud",
    "description": "Best Urbania rental service in Kothrud known for luxury vehicles, experienced drivers, punctual service, and excellent customer satisfaction."
  },
  {
    "name": "Book Urbania on rent in Kothrud",
    "description": "Book Urbania on rent in Kothrud easily with flexible booking options, premium AC vehicles, and dependable service."
  },
  {
    "name": "Online Urbania Bus booking in Kothrud",
    "description": "Online Urbania bus booking in Kothrud for quick and hassle-free reservations with well-maintained vehicles and professional chauffeurs."
  },
  {
    "name": "13 Seater Urbania On Rent in Kothrud Pune",
    "description": "13 seater Urbania on rent in Kothrud Pune for families and small groups with AC comfort, luggage space, and experienced drivers."
  },
  {
    "name": "Luxury Force Urbania Hire Kothrud",
    "description": "Luxury Force Urbania hire in Kothrud offering a premium travel experience with high-end AC interiors and courteous chauffeurs."
  },
  {
    "name": "Urbania Airport Transfer Service from Kothrud",
    "description": "Urbania airport transfer service from Kothrud providing timely pickup and drop with luxury AC vehicles and reliable drivers."
  }
],
"tableData": [
  ["Urbania on rent in Kothrud Pune", "Force Urbania on rent Kothrud"],
  ["Urbania rental service Kothrud", "Urbania Bus hire in Kothrud"],
  ["13 seater Urbania on rent Kothrud", "17 seater Urbania on rent Kothrud"],
  ["Luxury Urbania hire Kothrud", "AC Urbania Bus hire Kothrud"],
  ["Urbania on rent near Karve Nagar", "Urbania hire near Paud Road Kothrud"],
  ["Urbania rental near Ideal Colony", "Urbania Bus hire near Bavdhan"],
  ["Urbania on rent near Warje Malwadi", "Urbania on rent Kothrud for family trip"],
  ["Urbania hire Kothrud for outstation", "Urbania rental Kothrud for wedding"],
  ["Urbania hire Kothrud for corporate travel", "Urbania van hire Kothrud for picnic"],
  ["Urbania airport pickup from Kothrud", "Urbania Pune Airport drop from Kothrud"],
  ["Urbania hire Kothrud per km rate", "Affordable Urbania Rental Kothrud"],
  ["Cheap Urbania on rent Kothrud", "Best Urbania Rental service Kothrud"],
  ["Book Urbania on rent in Kothrud", "Online Urbania Bus booking in Kothrud"],
  ["13 Seater Urbania On Rent in Kothrud Pune", "Urbania Airport Transfer Service from Kothrud"]
],




"whychoose": [
  {
    "WhyChooseheading": "Trusted Force Urbania Rental in Aundh Pune",
    "WhyChoosedescription": "Amruta Travels offers Force Urbania Rental in Aundh Pune, providing comfortable, stylish, and reliable travel solutions for corporate trips, family outings, and group travel."
  },
  {
    "WhyChooseheading": "Ideal for Corporate, Family, and Event Travel",
    "WhyChoosedescription": "Whether it’s a corporate meeting, family outing, wedding transport, or VIP travel, our Force Urbania rentals in Aundh ensure a smooth and comfortable journey."
  },
  {
    "WhyChooseheading": "Spacious and Luxurious Interiors",
    "WhyChoosedescription": "The Force Urbania features plush seating, ample legroom, air conditioning, large windows, and generous luggage space, making it perfect for city travel and long-distance journeys."
  },
  {
    "WhyChooseheading": "Professional and Courteous Drivers",
    "WhyChoosedescription": "All Force Urbania rentals include trained and courteous drivers who ensure punctuality, safety, and a stress-free travel experience throughout Aundh and Pune."
  },
  {
    "WhyChooseheading": "Affordable Pricing with Transparency",
    "WhyChoosedescription": "Amruta Travels provides competitive and transparent pricing for Force Urbania rental in Aundh Pune, ensuring value for money without any hidden charges."
  },
  {
    "WhyChooseheading": "Clean, Well-Maintained, and Sanitized Vehicles",
    "WhyChoosedescription": "Our Force Urbania vehicles are regularly serviced and sanitized to maintain high standards of hygiene, safety, and passenger comfort."
  },
  {
    "WhyChooseheading": "Flexible Pickup, Drop-Off, and Route Planning",
    "WhyChoosedescription": "We offer flexible pickup and drop-off locations along with customized routes to suit your travel plan within Aundh, Pune, or nearby destinations."
  },
  {
    "WhyChooseheading": "Easy Booking with Dedicated Support",
    "WhyChoosedescription": "Booking a Force Urbania rental in Aundh Pune is simple and hassle-free with Amruta Travels. Our support team assists you at every step for a seamless experience."
  }
]

    }

const faqData = [
  {
    question: 'How can I book Force Urbania rental in Aundh Pune?',
    answer: 'You can book Force Urbania rental in Aundh Pune by contacting Amruta Travels online, via phone, or by visiting our office. Our team will assist you throughout the booking process.'
  },
  {
    question: 'Is Force Urbania suitable for corporate travel from Aundh?',
    answer: 'Yes, Force Urbania is ideal for corporate travel, offering spacious seating, air conditioning, and comfort for employees and clients traveling from Aundh.'
  },
  {
    question: 'Can I rent Force Urbania in Aundh for outstation trips?',
    answer: 'Yes, we provide Force Urbania rentals from Aundh for both local and outstation travel, ensuring a smooth and comfortable journey.'
  },
  {
    question: 'Does the Force Urbania rental include a driver?',
    answer: 'Yes, every Force Urbania rental includes a professional and experienced driver for safe and hassle-free travel.'
  },
  {
    question: 'Are the Force Urbania vehicles well-maintained?',
    answer: 'Absolutely. All Force Urbania vehicles are regularly serviced, cleaned, and sanitized to maintain hygiene, safety, and passenger comfort.'
  },
  {
    question: 'What is the cost of Force Urbania rental in Aundh Pune?',
    answer: 'The rental cost depends on distance, duration, and type of travel. Contact Amruta Travels for a transparent and customized quote.'
  },
  {
    question: 'Can I customize pickup and drop-off locations in Aundh?',
    answer: 'Yes, we offer flexible pickup and drop-off options and route customization based on your travel needs.'
  },
  {
    question: 'Why choose Amruta Travels for Force Urbania rental in Aundh Pune?',
    answer: 'Amruta Travels offers well-maintained Force Urbania vehicles, professional drivers, transparent pricing, and reliable support, ensuring a premium travel experience.'
  }
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Rohit Jadhav',
    role: 'Corporate Manager, Aundh',
    text: 'We rented a Force Urbania from Aundh for a corporate outing. The vehicle was clean, spacious, and the driver was professional. Excellent service by Amruta Travels!',
    rating: 5
  },
  {
    id: 2,
    name: 'Mrs. Priya Kulkarni',
    role: 'Family Traveler, Aundh',
    text: 'Booked a Force Urbania rental in Aundh for a family trip. The ride was smooth, comfortable, and hassle-free. Highly recommend Amruta Travels!',
    rating: 5
  }
];
























































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Force Urbania Rental in Aundh Pune",
  "image": "https://bushireinpune.com/assets/images/force-urbania-aundh.jpg",
  "description": "Force Urbania rental in Aundh Pune with Amruta Travels. Rent 13 & 17 seater Urbania vans for corporate travel, airport transfers, family trips, IT company commutes, weddings, and local sightseeing. Service areas include University Circle, Bremen Chowk, Baner, Pashan, Wakad Road, and nearby Aundh locations with professional drivers and affordable per km rates.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "2850"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "6300",
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/force-urbania-rental-aundh"
  }
};





    return (
        <div>

<Helmet>
  <title>Call: +91 7353109555 | Force Urbania Rental in Aundh Pune | Urbania Hire | Amruta Travels</title>
  <meta
    name="description"
    content="Force Urbania rental in Aundh Pune with Amruta Travels. Rent 13 & 17 seater Urbania vans for corporate travel, airport transfers, family trips, IT company commutes, weddings, and local sightseeing at affordable rates."
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/115.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Forceurbaniarentalinaundhpune;